import {Component, Input, OnInit} from '@angular/core';
import {DescriptionModel} from '../../../models/shared/description.model';
import {EvoLangDropdownComponent} from '../evo-lang-dropdown/evo-lang-dropdown.component';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {DropdownModel} from '../../../models/component/dropdown.model';

@Component({
  selector: 'app-evo-translated-input',
  templateUrl: './evo-translated-input.component.html',
  styleUrls: ['./evo-translated-input.component.css']
})
export class EvoTranslatedInputComponent implements OnInit {

  _culture = CultureModel.enGB;
  @Input('culture')
  set culture(value: string) {
    this._culture = value;
  }

  get culture(): string {
    return this._culture;
  }

  @Input() descr = new DescriptionModel();
  @Input() inputTitle = 'Translations';
  @Input() disableCultureSelection = false;
  @Input() cultures: DropdownModel[] = CultureModel.dropdownList();

  constructor() { }

  ngOnInit() {
  }

  getCurrentValue(): string {

    return this.descr[this.culture];
  }

  setCurrentValue(value: string) {
    this.descr[this.culture] = value;
  }

  getCultures(): DropdownModel[] {

    if (this.cultures.length > 0) {

      return this.cultures;
    }

    return CultureModel.dropdownList();
  }

}
